import './experience.css';

function Resume() {
  return (
    <div className="resume-page">

      {/* Resume PDF Viewer */}
      <div className="resume-section">
        <h2 className="section-title">Resume</h2>
        <div className="resume-viewer">
          <iframe
            src="/CJC-SWE-RESUME.pdf"
            width="100%"
            height="100%"
            style={{ border: 'none' }}
            title="Resume"
          />
        </div>
        <a href="/CJC-SWE-RESUME.pdf" download className="btn-download">
          Download PDF
        </a>
      </div>

      {/* GitHub Profile Card */}
      <div className="github-section">
        <h2 className="section-title">GitHub</h2>
        <p className="github-desc">Explore my open-source projects and contributions.</p>
        <a
          href="https://github.com/charliecarroll222"
          target="_blank"
          rel="noopener noreferrer"
          className="btn-github"
        >
          View GitHub Profile →
        </a>
      </div>

    </div>
  );
}

export default Resume;
